export type Country = {
  code: string
  name: string
}

const PREFERRED = ['CZ', 'SK', 'PL', 'DE', 'AT']

// Czech names, ISO 3166-1 alpha-2 codes.
const all: Country[] = [
  { code: 'AF', name: 'Afghánistán' },
  { code: 'AL', name: 'Albánie' },
  { code: 'DZ', name: 'Alžírsko' },
  { code: 'AS', name: 'Americká Samoa' },
  { code: 'VI', name: 'Americké Panenské ostrovy' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AQ', name: 'Antarktida' },
  { code: 'AG', name: 'Antigua a Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Arménie' },
  { code: 'AW', name: 'Aruba' },
  { code: 'AU', name: 'Austrálie' },
  { code: 'AZ', name: 'Ázerbájdžán' },
  { code: 'BS', name: 'Bahamy' },
  { code: 'BH', name: 'Bahrajn' },
  { code: 'BD', name: 'Bangladéš' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BE', name: 'Belgie' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BM', name: 'Bermudy' },
  { code: 'BT', name: 'Bhútán' },
  { code: 'BO', name: 'Bolívie' },
  { code: 'BA', name: 'Bosna a Hercegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BV', name: 'Bouvetův ostrov' },
  { code: 'BR', name: 'Brazílie' },
  { code: 'IO', name: 'Britské indickooceánské území' },
  { code: 'VG', name: 'Britské Panenské ostrovy' },
  { code: 'BN', name: 'Brunej' },
  { code: 'BG', name: 'Bulharsko' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'CK', name: 'Cookovy ostrovy' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'TD', name: 'Čad' },
  { code: 'ME', name: 'Černá Hora' },
  { code: 'CZ', name: 'Česká republika' },
  { code: 'CN', name: 'Čína' },
  { code: 'DK', name: 'Dánsko' },
  { code: 'CD', name: 'Demokratická republika Kongo' },
  { code: 'DM', name: 'Dominika' },
  { code: 'DO', name: 'Dominikánská republika' },
  { code: 'DJ', name: 'Džibutsko' },
  { code: 'EG', name: 'Egypt' },
  { code: 'EC', name: 'Ekvádor' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonsko' },
  { code: 'ET', name: 'Etiopie' },
  { code: 'FO', name: 'Faerské ostrovy' },
  { code: 'FK', name: 'Falklandské ostrovy (Malvíny)' },
  { code: 'FJ', name: 'Fidži' },
  { code: 'PH', name: 'Filipíny' },
  { code: 'FI', name: 'Finsko' },
  { code: 'FR', name: 'Francie' },
  { code: 'GF', name: 'Francouzská Guyana' },
  { code: 'PF', name: 'Francouzská Polynésie' },
  { code: 'TF', name: 'Francouzská jižní a antarktická území' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambie' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GR', name: 'Řecko' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GL', name: 'Grónsko' },
  { code: 'GE', name: 'Gruzie' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'GU', name: 'Guam' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HM', name: 'Heardův ostrov a McDonaldovy ostrovy' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hongkong' },
  { code: 'CL', name: 'Chile' },
  { code: 'HR', name: 'Chorvatsko' },
  { code: 'IN', name: 'Indie' },
  { code: 'ID', name: 'Indonésie' },
  { code: 'IQ', name: 'Irák' },
  { code: 'IR', name: 'Írán' },
  { code: 'IE', name: 'Irsko' },
  { code: 'IS', name: 'Island' },
  { code: 'IT', name: 'Itálie' },
  { code: 'IL', name: 'Izrael' },
  { code: 'JM', name: 'Jamajka' },
  { code: 'JP', name: 'Japonsko' },
  { code: 'YE', name: 'Jemen' },
  { code: 'KH', name: 'Kambodža' },
  { code: 'CM', name: 'Kamerun' },
  { code: 'CA', name: 'Kanada' },
  { code: 'CV', name: 'Kapverdy' },
  { code: 'QA', name: 'Katar' },
  { code: 'KZ', name: 'Kazachstán' },
  { code: 'KE', name: 'Keňa' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'CC', name: 'Kokosové (Keelingovy) ostrovy' },
  { code: 'CO', name: 'Kolumbie' },
  { code: 'KM', name: 'Komory' },
  { code: 'CG', name: 'Kongo' },
  { code: 'KR', name: 'Korea' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'CR', name: 'Kostarika' },
  { code: 'CU', name: 'Kuba' },
  { code: 'KW', name: 'Kuvajt' },
  { code: 'CY', name: 'Kypr' },
  { code: 'KG', name: 'Kyrgyzstán' },
  { code: 'LA', name: 'Laos' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LB', name: 'Libanon' },
  { code: 'LR', name: 'Libérie' },
  { code: 'LY', name: 'Libye' },
  { code: 'LI', name: 'Lichtenštejnsko' },
  { code: 'LT', name: 'Litva' },
  { code: 'LV', name: 'Lotyšsko' },
  { code: 'LU', name: 'Lucembursko' },
  { code: 'MO', name: 'Macao' },
  { code: 'MG', name: 'Madagaskar' },
  { code: 'HU', name: 'Maďarsko' },
  { code: 'MK', name: 'Makedonie' },
  { code: 'MY', name: 'Malajsie' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MV', name: 'Maledivy' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'IM', name: 'Man' },
  { code: 'MA', name: 'Maroko' },
  { code: 'MH', name: 'Marshallovy ostrovy' },
  { code: 'MQ', name: 'Martinik' },
  { code: 'MU', name: 'Mauricius' },
  { code: 'MR', name: 'Mauritánie' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'MX', name: 'Mexiko' },
  { code: 'FM', name: 'Mikronésie' },
  { code: 'MD', name: 'Moldavsko' },
  { code: 'MC', name: 'Monako' },
  { code: 'MN', name: 'Mongolsko' },
  { code: 'MS', name: 'Montserrat' },
  { code: 'MZ', name: 'Mosambik' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibie' },
  { code: 'NR', name: 'Nauru' },
  { code: 'DE', name: 'Německo' },
  { code: 'NP', name: 'Nepál' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigérie' },
  { code: 'NI', name: 'Nikaragua' },
  { code: 'NU', name: 'Niue' },
  { code: 'NL', name: 'Nizozemsko' },
  { code: 'NF', name: 'Norfolk' },
  { code: 'NO', name: 'Norsko' },
  { code: 'NC', name: 'Nová Kaledonie' },
  { code: 'NZ', name: 'Nový Zéland' },
  { code: 'OM', name: 'Omán' },
  { code: 'PK', name: 'Pákistán' },
  { code: 'PW', name: 'Palau' },
  { code: 'PS', name: 'Palestina' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua-Nová Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PN', name: 'Pitcairnovy ostrovy' },
  { code: 'CI', name: 'Pobřeží slonoviny' },
  { code: 'PL', name: 'Polsko' },
  { code: 'PR', name: 'Portoriko' },
  { code: 'PT', name: 'Portugalsko' },
  { code: 'AT', name: 'Rakousko' },
  { code: 'GQ', name: 'Rovníková Guinea' },
  { code: 'RO', name: 'Rumunsko' },
  { code: 'RU', name: 'Rusko' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'RE', name: 'Réunion' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'SA', name: 'Saúdská Arábie' },
  { code: 'SN', name: 'Senegal' },
  { code: 'KP', name: 'Severní Korea' },
  { code: 'MP', name: 'Severní Mariany' },
  { code: 'SC', name: 'Seychely' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapur' },
  { code: 'SX', name: 'Sint Maarten' },
  { code: 'SK', name: 'Slovensko' },
  { code: 'SI', name: 'Slovinsko' },
  { code: 'SO', name: 'Somálsko' },
  { code: 'AE', name: 'Spojené arabské emiráty' },
  { code: 'GB', name: 'Spojené království' },
  { code: 'US', name: 'Spojené státy americké' },
  { code: 'RS', name: 'Srbsko' },
  { code: 'CF', name: 'Středoafrická republika' },
  { code: 'SD', name: 'Súdán' },
  { code: 'SR', name: 'Surinam' },
  { code: 'SH', name: 'Svatá Helena' },
  { code: 'LC', name: 'Svatá Lucie' },
  { code: 'BL', name: 'Svatý Bartoloměj' },
  { code: 'KN', name: 'Svatý Kryštof a Nevis' },
  { code: 'MF', name: 'Svatý Martin' },
  { code: 'PM', name: 'Svatý Pierre a Miquelon' },
  { code: 'ST', name: 'Svatý Tomáš a Princův ostrov' },
  { code: 'VC', name: 'Svatý Vincenc a Grenadiny' },
  { code: 'SZ', name: 'Svazijsko' },
  { code: 'SY', name: 'Sýrie' },
  { code: 'SB', name: 'Šalomounovy ostrovy' },
  { code: 'ES', name: 'Španělsko' },
  { code: 'SE', name: 'Švédsko' },
  { code: 'CH', name: 'Švýcarsko' },
  { code: 'TJ', name: 'Tádžikistán' },
  { code: 'TZ', name: 'Tanzanie' },
  { code: 'TH', name: 'Thajsko' },
  { code: 'TW', name: 'Tchaj-wan' },
  { code: 'TG', name: 'Togo' },
  { code: 'TK', name: 'Tokelau' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad a Tobago' },
  { code: 'TN', name: 'Tunisko' },
  { code: 'TR', name: 'Turecko' },
  { code: 'TM', name: 'Turkmenistán' },
  { code: 'TC', name: 'Turks a Caicos' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukrajina' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistán' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatikán' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'TL', name: 'Východní Timor' },
  { code: 'WF', name: 'Wallis a Futuna' },
  { code: 'ZM', name: 'Zambie' },
  { code: 'ZW', name: 'Zimbabwe' },
]

const rank = (country: Country): number => {
  const index = PREFERRED.indexOf(country.code)
  return index === -1 ? PREFERRED.length : index
}

/** Neighbouring countries first, then in alphabetical order (stable sort keeps it). */
export const countries: readonly Country[] = [...all].sort((a, b) => rank(a) - rank(b))

/**
 * Country code for a stored country value. Older addresses store the Czech name ("Česká Republika")
 * instead of the code; unknown values are returned unchanged.
 */
export const countryCode = (value: string): string => {
  const normalized = value.trim().toLocaleLowerCase('cs')
  return (
    countries.find((country) => country.code.toLowerCase() === normalized || country.name.toLocaleLowerCase('cs') === normalized)
      ?.code ?? value
  )
}
